/* eslint-disable */
import * as React from "react";

import { useParameter } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { CommoditiesControl } from "../controls/CommoditiesControl";
import { ForecastSourcesControl } from "../controls/ForecastSourcesControl";
import { useFavourite } from "./useFavourite";

export default function () {
  const [commodity] = useParameter<number>("@commodities");

  useFavourite();
  return (
    <ReportToolbarGroup vertical>
      <CommoditiesControl />
      <ForecastSourcesControl key={commodity || undefined} />
    </ReportToolbarGroup>
  );
}
